export var WhoRewardedRewardTypes;
(function (WhoRewardedRewardTypes) {
    WhoRewardedRewardTypes["OLD_REWARD"] = "OLD_REWARD";
    WhoRewardedRewardTypes["NEW_REWARD"] = "NEW_REWARD";
    WhoRewardedRewardTypes["CUSTOM_OLD_REWARD"] = "CUSTOM_OLD_REWARD";
    WhoRewardedRewardTypes["CUSTOM_NEW_REWARD"] = "CUSTOM_NEW_REWARD";
    WhoRewardedRewardTypes["CREDIT_REWARD"] = "CREDIT_REWARD";
    WhoRewardedRewardTypes["NO_REWARD"] = "NO_REWARD";
})(WhoRewardedRewardTypes || (WhoRewardedRewardTypes = {}));
export var WhoRewardedVisibilityTypes;
(function (WhoRewardedVisibilityTypes) {
    WhoRewardedVisibilityTypes["FULL"] = "FULL";
    WhoRewardedVisibilityTypes["LIMITED"] = "LIMITED";
    WhoRewardedVisibilityTypes["HIDDEN"] = "HIDDEN";
})(WhoRewardedVisibilityTypes || (WhoRewardedVisibilityTypes = {}));
export var WhoRewardedTypes;
(function (WhoRewardedTypes) {
    WhoRewardedTypes["SENDER"] = "SENDER";
    WhoRewardedTypes["RECEIVER"] = "RECEIVER";
    WhoRewardedTypes["VIEWER"] = "VIEWER";
    WhoRewardedTypes["NO_USER"] = "NO_USER";
})(WhoRewardedTypes || (WhoRewardedTypes = {}));
